import { AlertTriangle, Check, Clock, Loader2 } from "lucide-react";
import { ISSUE_STATUS_LABELS } from "../services/app/constants";
import type { TranscriptionStatus } from "../services/db/schema";

interface StatusBadgeProps {
  status: TranscriptionStatus;
}

export function StatusBadge({ status }: StatusBadgeProps): JSX.Element {
  const label = ISSUE_STATUS_LABELS[status];
  const Icon =
    status === "approved" || status === "not_needed"
      ? Check
      : status === "error" || status === "needs_note"
        ? AlertTriangle
        : status === "transcribing"
          ? Loader2
          : Clock;
  return (
    <span className={`badge badge--${status}`} aria-label={`Status: ${label}`}>
      <Icon size={14} aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
